module.exports = __webpack_public_path__ + "static/media/31a 50-50.3db48812.jpg";